export default "__VITE_ASSET___i2QiR3d__"